import type { IconData } from '@stacksjs/iconify-core'

export const lifeRing: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M425.706 86.294A240 240 0 0 0 86.294 425.706A240 240 0 0 0 425.706 86.294m-80.04 236.745a111.78 111.78 0 0 0 0-134.078l68.218-68.218a207.58 207.58 0 0 1 0 270.514ZM176 256a80 80 0 1 1 80 80a80.09 80.09 0 0 1-80-80M391.257 98.116l-68.218 68.218a111.78 111.78 0 0 0-134.078 0l-68.218-68.218a207.58 207.58 0 0 1 270.514 0M98.116 120.743l68.218 68.218a111.78 111.78 0 0 0 0 134.078l-68.218 68.218a207.58 207.58 0 0 1 0-270.514m22.627 293.141l68.218-68.218a111.78 111.78 0 0 0 134.078 0l68.218 68.218a207.58 207.58 0 0 1-270.514 0\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default lifeRing
